export default __webpack_public_path__ + "static/media/sidebar-bulletinboard.7e0b62d4.svg";